import { canUseWebP } from 'js/utils/general';

// Target site ID
export const DOM_ID = 'react-microsite';

// Dates
const DATE = new Date();
const DATE_DAY = DATE.getDate();
const DATE_MONTH = DATE.getMonth() + 1; // Jan is 0
const DATE_YEAR = DATE.getFullYear();
export const DATE_TODAY = Date.parse(DATE_MONTH + '/' + DATE_DAY + '/' + DATE_YEAR);
export const DATE_TOMORROW = Date.parse(DATE_MONTH + '/' + (DATE_DAY + 1) + '/' + DATE_YEAR);
export const CURRENT_DATE = new Date().getDay() === 0 ? 7 : new Date().getDay();

// Localstorage
// -- also used for persistStore
export const LOCAL_STORAGE_NAME = 'stanandgran';

// base urls
export const BASE_URL = window?.siteData?.base_url ? window.siteData.base_url + '/' : import.meta.env.VITE_BASE_URL;
export const ASSET_URL = window?.siteData?.asset_url ? window.siteData.asset_url + '/' : BASE_URL;
export const BASE_API_URL = window?.siteData?.api_url
  ? window?.siteData.api_url + '/'
  : import.meta.env.VITE_BASE_API_URL;

// Picture mappings
export const WEBPSUPPORT = canUseWebP();

export const CACHEBUST = window?.siteData?.cachebust ? window.siteData.cachebust : '';

// Language
export const LANGUAGE = window.siteData?.locale ?? 'en_GB';
